import BoxLoading from './box.component';

export default BoxLoading;